import { apiClient } from "./api";
import { toast } from "sonner";

/**
 * Upload up to 5 images (mixed images + PDFs). Every PDF page is converted
 * to an image on the backend and every image is compressed. Returns an object
 * `{ images: [dataURL,...], rejected_pages, limit }`.
 *
 * Shows a toast on partial rejection so the caller doesn't need to duplicate
 * that UX.
 */
export async function uploadAttachments(files, { existingCount = 0 } = {}) {
  const list = Array.from(files || []);
  if (list.length === 0) return { images: [], rejected_pages: 0, limit: 5 };
  const fd = new FormData();
  for (const f of list) fd.append("files", f, f.name);
  const r = await apiClient.post("/upload/attachments", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  const data = r.data || {};
  const room = Math.max(0, 5 - existingCount);
  // Trim if the caller already had some pages so we never exceed 5 client-side.
  const kept = (data.images || []).slice(0, room);
  const rejected = (data.images || []).length - kept.length + (data.rejected_pages || 0);
  if (rejected > 0) {
    toast.error(
      `You can attach at most 5 images per enquiry — ${rejected} page${rejected === 1 ? "" : "s"} not added. Please upload the rest separately.`
    );
  }
  return { images: kept, rejected_pages: rejected, limit: data.limit || 5 };
}
